import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'premium' | 'new';
  size?: 'sm' | 'md';
  className?: string;
}

export function Badge({ children, variant = 'default', size = 'sm', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center font-medium rounded-full',
        // Size
        size === 'sm' && 'px-2.5 py-0.5 text-xs',
        size === 'md' && 'px-3 py-1 text-sm',
        // Variants
        variant === 'default' && 'bg-slate-700/50 text-slate-300 border border-slate-600/50',
        variant === 'success' && 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20',
        variant === 'warning' && 'bg-amber-500/10 text-amber-400 border border-amber-500/20',
        variant === 'premium' &&
          'bg-gradient-to-r from-indigo-500/15 via-purple-500/15 to-indigo-500/15 text-indigo-200 border border-indigo-400/30 shadow-sm shadow-indigo-500/10',
        variant === 'new' && 'bg-cyan-500/10 text-cyan-300 border border-cyan-400/25',
        className
      )}
    >
      {children}
    </span>
  );
}
